const validateEmail = () => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  };
  export default validateEmail;
  